import { apiDireccionesColonias, apiDireccionesEstadosMunicipios, apiDireccionesPaises } from "../settings/apiConfig";
import { createContext, useContext, useEffect, useState } from "react";
import { enumPaisMex, enumPaisMexico, enumProveedorStep } from "../settings/enumConfig";
import { fnHandleChangeText, fnHandleChangeTextNotError } from "../settings/handleConfig";

import { getDomicilioFiscalModel } from "../model/domicilioFiscalModel";
import { useDatosCompania } from "./DatosCompaniaContext";
import { useProveedoresProspectos } from "./ProveedoresProspectosContext";
import { useRequest } from "./RequestContext";

export const DomicilioFiscalContext = createContext();

export const DomicilioFiscalProvider = (props) => {
    const { Get } = useRequest();
    const { provedoresSteps, entSolicitudDetalleForEdit, handleChangeProveedoresStep, handleClickResetStepError, handleChangeStep } =
        useProveedoresProspectos();
    const { datosCompaniaForm } = useDatosCompania();

    const [listaPaises, setListaPaises] = useState([]);
    const [listaEstados, setListaEstados] = useState([]);
    const [listaMunicipios, setListaMunicipios] = useState([]);
    const [listaCiudades, setListaCiudades] = useState([]);
    const [listaColonias, setListaColonias] = useState([]);
    const [entDomicilioFiscal, setEntDomicilioFiscal] = useState(null);

    const [domicilioFiscalForm, setDomicilioFiscalForm] = useState(getDomicilioFiscalModel());
    const [paisMexicoValidacion, setPaisMexicoValidacion] = useState(false);

    const handleChangeDomicilioFiscalForm = fnHandleChangeText(domicilioFiscalForm, setDomicilioFiscalForm);
    const handleChangeDomicilioFiscalFormNotError = fnHandleChangeTextNotError(domicilioFiscalForm, setDomicilioFiscalForm);

    const handleClickGetPaises = async () => {
        const response = await CGetPais();
        if (response.Code === 0) {
            setListaPaises(response.Result);
            if (response.Result.map((x) => x.sPais).includes(enumPaisMex)) {
                const { txtPais } = domicilioFiscalForm;
                setDomicilioFiscalForm({
                    ...domicilioFiscalForm,
                    txtPais: {
                        ...txtPais,
                        value: enumPaisMexico,
                    },
                });
            }
        } else {
            setListaPaises([]);
        }
    };

    const handleChangePaisSeleccionado = async (e, value) => {
        const { txtCodigoPostal } = domicilioFiscalForm;
        const paisEval = JSON.stringify(value) === JSON.stringify(enumPaisMexico);
        if (paisEval) {
            if (txtCodigoPostal.value.length !== 5) {
                fnResetAddressFormByPais(value);
            } else {
                await fnGetAddressByZip(value);
            }
        } else {
            fnResetAddressFormByPais(value);
        }
    };

    const handleClickGetEstados = async () => {
        const response = await CGetEstadoMunicipio();
        if (response.Code === 0) {
            setListaEstados(response.Result);
        } else {
            setListaEstados([]);
        }
    };

    const handleChangeEstado = (e) => {
        const { txtCiudad, txtColonia, txtEstado, txtMunicipio } = domicilioFiscalForm;
        const entEstado = listaEstados.find((x) => x.sEstado === e.target.value);

        const lstMunicipiosTemp = !entEstado ? [] : entEstado.lstMunicipios;

        setListaMunicipios(lstMunicipiosTemp);
        setListaCiudades([]);
        setListaColonias([]);

        setDomicilioFiscalForm({
            ...domicilioFiscalForm,
            txtEstado: { ...txtEstado, value: e.target.value, error: false },
            txtMunicipio: { ...txtMunicipio, value: "", error: false },
            txtCiudad: { ...txtCiudad, value: "", error: false },
            txtColonia: { ...txtColonia, value: "", error: false },
        });
    };

    const handleChangeMunicipio = (e) => {
        const { txtCiudad, txtColonia, txtMunicipio } = domicilioFiscalForm;
        const entMunicipio = listaMunicipios.find((x) => x.sMunicipio === e.target.value);
        const lstCiudadesTemp = !entMunicipio ? [] : entMunicipio.lstCiudades;

        setListaCiudades(lstCiudadesTemp);
        setListaColonias([]);

        setDomicilioFiscalForm({
            ...domicilioFiscalForm,
            txtMunicipio: { ...txtMunicipio, value: e.target.value, error: false },
            txtCiudad: { ...txtCiudad, value: "", error: false },
            txtColonia: { ...txtColonia, value: "", error: false },
        });
    };

    const handleBlurCodigoPostal = async () => {
        const { txtCodigoPostal, txtPais } = domicilioFiscalForm;
        if (txtCodigoPostal.value.length === 5 && JSON.stringify(txtPais.value) === JSON.stringify(enumPaisMexico)) {
            await fnGetAddressByZip();
        }
    };

    const fnResetAddressFormByPais = (value) => {
        const { txtCiudad, txtColonia, txtOtraColonia, txtEstado, txtMunicipio, txtPais } = domicilioFiscalForm;
        const lstColoniasStr = listaColonias.map((x) => x.sColonia);

        setDomicilioFiscalForm({
            ...domicilioFiscalForm,
            txtEstado: { ...txtEstado, error: false },
            txtMunicipio: { ...txtMunicipio, error: false },
            txtCiudad: { ...txtCiudad, error: false },
            txtColonia: {
                ...txtColonia,
                value:
                    JSON.stringify(value) !== JSON.stringify(enumPaisMexico)
                        ? txtColonia.value === "#OTRA#"
                            ? txtOtraColonia.value
                            : txtColonia.value
                        : !lstColoniasStr.includes(txtColonia.value)
                        ? "#OTRA#"
                        : txtColonia.value,
                error: false,
            },
            txtPais: { ...txtPais, value, error: !value },
        });
        setListaMunicipios([]);
        setListaCiudades([]);
        setListaColonias([]);
    };

    const fnGetAddressByZip = async (value = null) => {
        const { txtPais, txtCiudad, txtCodigoPostal, txtColonia, txtOtraColonia, txtEstado, txtMunicipio } = domicilioFiscalForm;
        const response = await CGetColoniaByZipCode(txtCodigoPostal.value);
        if (response.Code === 0) {
            const { sEstado, sMunicipio, sCiudad, lstColonias } = response.Result;
            if (sEstado !== "") {
                const entEstado = listaEstados.find((x) => x.sEstado === sEstado);
                const lstMunicipiosTemp = !entEstado ? [] : entEstado.lstMunicipios;

                setListaMunicipios(lstMunicipiosTemp);

                if (lstMunicipiosTemp.length > 0 && sMunicipio !== "") {
                    const entMunicipio = lstMunicipiosTemp.find((x) => x.sMunicipio === sMunicipio);
                    const lstCiudadesTemp = !entMunicipio ? [] : entMunicipio.lstCiudades;

                    setListaCiudades(lstCiudadesTemp);
                }
            } else {
                setListaMunicipios([]);
                setListaCiudades([]);
            }

            setListaColonias(lstColonias);
            const lstColoniasStr = listaColonias.map((x) => x.sColonia);

            setDomicilioFiscalForm({
                ...domicilioFiscalForm,
                txtEstado: { ...txtEstado, value: sEstado, error: false },
                txtMunicipio: { ...txtMunicipio, value: sMunicipio, error: false },
                txtCiudad: { ...txtCiudad, value: sCiudad, error: false },
                txtColonia: {
                    ...txtColonia,
                    value:
                        txtColonia.value !== "" &&
                        JSON.stringify(value) === JSON.stringify(enumPaisMexico) &&
                        lstColoniasStr.includes(txtColonia.value)
                            ? txtColonia.value
                            : "#OTRA#",
                    error: false,
                },
                txtOtraColonia: {
                    ...txtOtraColonia,
                    value:
                        txtColonia.value !== "" &&
                        JSON.stringify(value) === JSON.stringify(enumPaisMexico) &&
                        !lstColoniasStr.includes(txtColonia.value)
                            ? txtColonia.value
                            : "",
                },
                txtPais: { ...txtPais, value: !value ? txtPais.value : value, error: false },
            });
        }
    };

    const handleClickRegresar = () => {
        handleChangeStep(enumProveedorStep.GiroPrincipal);
        handleClickResetStepError();
    };

    const handleClickSiguiente = () => {
        const {
            txtCalle,
            txtCiudad,
            txtCodigoPostal,
            txtColonia,
            txtOtraColonia,
            txtEstado,
            txtMunicipio,
            txtNumeroExterior,
            txtNumeroInterior,
            txtPais,
        } = domicilioFiscalForm;

        const tempForm = !paisMexicoValidacion
            ? {
                  ...domicilioFiscalForm,
                  txtNumeroExterior: {
                      ...txtNumeroExterior,
                      error: !txtNumeroExterior.required ? false : txtNumeroExterior.value === "",
                  },
                  txtPais: { ...txtPais, error: !txtPais.required ? false : !txtPais.value },
                  txtCalle: { ...txtCalle, error: false },
                  txtCiudad: { ...txtCiudad, error: false },
                  txtCodigoPostal: { ...txtCodigoPostal, error: false },
                  txtColonia: { ...txtColonia, error: false },
                  txtOtraColonia: { ...txtOtraColonia, error: false },
                  txtEstado: { ...txtEstado, error: false },
                  txtMunicipio: { ...txtMunicipio, error: false },
                  txtNumeroInterior: { ...txtNumeroInterior, error: false },
              }
            : {
                  ...domicilioFiscalForm,
                  txtCalle: { ...txtCalle, error: !txtCalle.required ? false : txtCalle.value === "" },
                  txtCiudad: { ...txtCiudad, error: !txtCiudad.required ? false : txtCiudad.value === "" },
                  txtCodigoPostal: { ...txtCodigoPostal, error: !txtCodigoPostal.required ? false : txtCodigoPostal.value === "" },
                  txtColonia: { ...txtColonia, error: !txtColonia.required ? false : txtColonia.value === "" },
                  txtOtraColonia: { ...txtOtraColonia, error: txtColonia.value === "#OTRA#" && txtOtraColonia.value === "" },
                  txtEstado: { ...txtEstado, error: !txtEstado.required ? false : txtEstado.value === "" },
                  txtMunicipio: { ...txtMunicipio, error: !txtMunicipio.required ? false : txtMunicipio.value === "" },
                  txtNumeroExterior: {
                      ...txtNumeroExterior,
                      error: !txtNumeroExterior.required ? false : txtNumeroExterior.value === "",
                  },
                  txtNumeroInterior: {
                      ...txtNumeroInterior,
                      error: !txtNumeroInterior.required ? false : txtNumeroInterior.value === "",
                  },
                  txtPais: { ...txtPais, error: !txtPais.required ? false : !txtPais.value },
              };

        setDomicilioFiscalForm(tempForm);

        if (
            Object.values(tempForm)
                .map((x) => x.error)
                .includes(true)
        ) {
            handleChangeProveedoresStep(
                provedoresSteps.map((x) => ({ ...x, error: x.id === enumProveedorStep.DomicilioFiscal ? true : false }))
            );
            return;
        } else {
            handleClickResetStepError();
        }

        const entDomicilioFiscalObj = {
            sCalle: txtCalle.value,
            sCiudad: txtCiudad.value,
            sCodigoPostal: txtCodigoPostal.value,
            sColonia: txtColonia.value === "#OTRA#" ? txtOtraColonia.value : txtColonia.value,
            sEstado: txtEstado.value,
            sMunicipio: txtMunicipio.value,
            sNumeroExterior: txtNumeroExterior.value,
            sNumeroInterior: txtNumeroInterior.value,
            sPais: txtPais.value.sPais,
        };

        setEntDomicilioFiscal(entDomicilioFiscalObj);

        handleChangeStep(enumProveedorStep.InformacionComplementaria);
    };

    const CGetPais = async () => {
        const payload = {
            url: apiDireccionesPaises,
        };

        return await Get(payload);
    };

    const CGetEstadoMunicipio = async () => {
        const payload = {
            url: apiDireccionesEstadosMunicipios,
        };

        return await Get(payload);
    };

    const CGetColoniaByZipCode = async (psCodigoPostal) => {
        const payload = {
            url: apiDireccionesColonias.replace("{psCodigoPostal}", psCodigoPostal),
        };

        return await Get(payload);
    };

    const fnFillFormDomicilioFiscal = async () => {
        if (!entSolicitudDetalleForEdit) {
            return;
        }

        const {
            txtCalle,
            txtCiudad,
            txtCodigoPostal,
            txtColonia,
            txtOtraColonia,
            txtEstado,
            txtMunicipio,
            txtNumeroExterior,
            txtNumeroInterior,
            txtPais,
        } = domicilioFiscalForm;

        const {
            entDomicilioFiscal: {
                sCalle,
                sCiudad,
                sCodigoPostal,
                sColonia,
                sEstado,
                sMunicipio,
                sNumeroExterior,
                sNumeroInterior,
                entPais,
            },
        } = entSolicitudDetalleForEdit;

        const response = await CGetColoniaByZipCode(sCodigoPostal);
        let lstColoniasStr = [];
        if (response.Code === 0) {
            const { sEstado, sMunicipio, lstColonias } = response.Result;
            if (sEstado !== "") {
                const entEstado = listaEstados.find((x) => x.sEstado === sEstado);
                const lstMunicipiosTemp = !entEstado ? [] : entEstado.lstMunicipios;
                setListaMunicipios(lstMunicipiosTemp);

                if (lstMunicipiosTemp.length > 0 && sMunicipio !== "") {
                    const entMunicipio = lstMunicipiosTemp.find((x) => x.sMunicipio === sMunicipio);
                    const lstCiudadesTemp = !entMunicipio ? [] : entMunicipio.lstCiudades;

                    setListaCiudades(lstCiudadesTemp);
                }
            } else {
                setListaMunicipios([]);
                setListaCiudades([]);
            }

            setListaColonias(lstColonias);
            lstColoniasStr = lstColonias.map((x) => x.sColonia);
        }

        setDomicilioFiscalForm({
            ...domicilioFiscalForm,
            txtCalle: { ...txtCalle, value: !sCalle ? "" : sCalle },
            txtCiudad: { ...txtCiudad, value: !sCiudad ? "" : sCiudad },
            txtCodigoPostal: { ...txtCodigoPostal, value: !sCodigoPostal ? "" : sCodigoPostal },
            txtColonia: {
                ...txtColonia,
                value: !sColonia
                    ? ""
                    : sColonia !== "" && !lstColoniasStr.includes(sColonia) && JSON.stringify(entPais) === JSON.stringify(enumPaisMexico)
                    ? "#OTRA#"
                    : sColonia,
            },
            txtOtraColonia: {
                ...txtOtraColonia,
                value: lstColoniasStr.includes(sColonia) && JSON.stringify(entPais) === JSON.stringify(enumPaisMexico) ? "" : sColonia,
            },
            txtEstado: { ...txtEstado, value: !sEstado ? "" : sEstado },
            txtMunicipio: { ...txtMunicipio, value: !sMunicipio ? "" : sMunicipio },
            txtNumeroExterior: { ...txtNumeroExterior, value: !sNumeroExterior ? "" : sNumeroExterior },
            txtNumeroInterior: { ...txtNumeroInterior, value: !sNumeroInterior ? "" : sNumeroInterior },
            txtPais: { ...txtPais, value: !entPais ? null : entPais },
        });
    };

    const handleChangLoadEvalPais = () => {
        const { txtPais, txtColonia, txtOtraColonia } = domicilioFiscalForm;
        const { txtTipoPersona } = datosCompaniaForm;
        const lstColoniasStr = listaColonias.map((x) => x.sColonia);

        setDomicilioFiscalForm({
            ...domicilioFiscalForm,
            txtPais: {
                ...txtPais,
                value:
                    txtTipoPersona.value > 1000
                        ? {
                              sCodigoPais: "US",
                              sPais: "UNITED STATES",
                          }
                        : enumPaisMexico,
            },
            txtColonia: {
                ...txtColonia,
                value:
                    // txtTipoPersona.value > 1000
                    //     ? txtOtraColonia.value
                    //     : txtColonia.value !== "" &&
                    //       !lstColoniasStr.includes(txtColonia.value) &&
                    //       JSON.stringify(txtPais.value) === JSON.stringify(enumPaisMexico)
                    //     ? "#OTRA#"
                    //     : txtColonia.value,
                    txtTipoPersona.value > 1000
                        ? txtColonia.value === "#OTRA#"
                            ? txtOtraColonia.value
                            : txtColonia.value
                        : txtColonia.value !== ""
                        ? txtColonia.value !== "#OTRA#" && !lstColoniasStr.includes(txtColonia.value)
                            ? "#OTRA#"
                            : txtColonia.value
                        : "",
            },
            txtOtraColonia: {
                ...txtOtraColonia,
                value:
                    // txtTipoPersona.value > 1000
                    //     ? ""
                    //     : lstColoniasStr.includes(txtColonia.value) && JSON.stringify(txtPais.value) === JSON.stringify(enumPaisMexico)
                    //     ? ""
                    //     : txtColonia.value,
                    txtTipoPersona.value > 1000
                        ? ""
                        : txtColonia.value !== "#OTRA#" && !lstColoniasStr.includes(txtColonia.value)
                        ? txtColonia.value
                        : txtOtraColonia.value,
            },
        });
    };

    useEffect(() => {
        const { txtPais } = domicilioFiscalForm;
        if (txtPais.value) {
            const paisEval = JSON.stringify(txtPais.value) === JSON.stringify(enumPaisMexico);
            setPaisMexicoValidacion(paisEval);
        } else {
            setPaisMexicoValidacion(false);
        }
    }, [domicilioFiscalForm]);

    useEffect(() => {
        handleClickGetPaises();
        handleClickGetEstados();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (listaPaises.length > 0 && listaEstados.length > 0 && entSolicitudDetalleForEdit) {
            fnFillFormDomicilioFiscal();
        }
        // eslint-disable-next-line
    }, [listaPaises, listaEstados, entSolicitudDetalleForEdit]);

    return (
        <DomicilioFiscalContext.Provider
            value={{
                listaPaises,
                listaEstados,
                listaMunicipios,
                listaCiudades,
                listaColonias,
                entDomicilioFiscal,
                domicilioFiscalForm,
                paisMexicoValidacion,
                handleClickGetPaises,
                handleClickGetEstados,
                handleChangeDomicilioFiscalForm,
                handleChangeDomicilioFiscalFormNotError,
                handleClickRegresar,
                handleClickSiguiente,
                handleChangeEstado,
                handleChangeMunicipio,
                handleBlurCodigoPostal,
                handleChangePaisSeleccionado,
                handleChangLoadEvalPais,
            }}
        >
            {props.children}
        </DomicilioFiscalContext.Provider>
    );
};

export const useDomicioFiscal = function () {
    return useContext(DomicilioFiscalContext);
};
